HuesMdl.controller( 'FansCtrl', ['$scope', 'hide', 'HuesUpdaterSrv', function ( $scope, hide, HuesUpdaterSrv ) {

	var self = this;

	this.hide = hide;

	$scope.$watch(function () { return HuesUpdaterSrv.hideHues;}, function( hideHues ){
		self.hide = hideHues;
	});
}]);
